<template>
    <svg 
        :class="iconClass" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
    >
        <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M6 18L18 6M6 6l12 12" 
        />
    </svg>
</template>

<script setup lang="ts">
    type IconClearProps = {
        iconClass?: string;
    }

    withDefaults(defineProps<IconClearProps>(), {
        iconClass: 'h-4 w-4',
    });
</script> 
